/**
 * The payer instance
 */
var player=undefined;

/**
 * The playlist passed
 */
var contentPlaylist={}

/**
 * Current index of the playlist
 */
var currentSourceIndex=0;

/**
 * Total duration of the playlist
 */
var playlistTotalDuration=0;

/**
 * Current file duration
 */
var currentFileDuration=0;

/**
 * Set the playlist for a sequence of files
 * @param {object} videojs 
 * @param {playlist} array 
 */
export function setFilePlaylist(videoJsWrapper,playlist){
    //set the player and the playlist
    player=videoJsWrapper.videojs;
    contentPlaylist=playlist;

    //reset the player
    _resetPlayer();

    //override the player UI
    _setPlaylistUi();

    //set the player's events
    _setPlayerEvents();
}

/**
 * Reset the player
 */
function _resetPlayer(){
    player.pause();
    currentSourceIndex=0;
    playlistTotalDuration=0;
    _loadSrc(currentSourceIndex);
}

/**
 * Set the UI of Video.Js
 */
function _setPlaylistUi(){
    //set the new progress bar
    let newProgressBar=player.controlBar.progressControl.seekBar.playProgressBar.el_.cloneNode(true);
    //get the parent progress par
    let parentProgressBar=player.controlBar.progressControl.seekBar.playProgressBar.el_.parentNode;
    //hide the default progress bar
    player.controlBar.progressControl.seekBar.playProgressBar.el_.style.display="none";
    //get the time tooltip
    let timeTooltip=player.controlBar.progressControl.seekBar.playProgressBar.el_.children[0];
    //add the new progress bar into the DOM
    let newToolTip=document.getElementsByClassName("vjs-time-tooltip")[0];
    newProgressBar.classList.add("newProgressBar");
    //remove the scrubber
    const style = document.createElement('style');
    const css = '.video-js .vjs-play-progress:before{display:none !important}';
    style.textContent = css;
    document.head.appendChild(style);
    try{
        //clean all children into the new progress bar
        newProgressBar.removeChild(newProgressBar.children[0]);
        //add the time tooltip 
        newProgressBar.appendChild(timeTooltip);
    }catch(error){}

    //show the new progress bar
    parentProgressBar.appendChild(newProgressBar);

    //get the slide bar holder
    let sliderBarHolder=document.getElementsByClassName("vjs-progress-holder")[0];
    //get the slide bar control
    let sliderBarControl=document.getElementsByClassName("vjs-progress-control")[0];

    //EVENT: on click over the slide bar holder
    "mousedown touchstart touchend".split(" ").forEach(function(e){
        sliderBarHolder.addEventListener(e, function(event){
            //set the loading UI
            _loadingUi((e=="touchend" ? false : true));
            //seek to the new clicked point into the scrollbar
            setTimeout(_onSeek,500,event,sliderBarHolder,0);
        });
      });

    //EVENT: on click over the slide bar control
    "mousedown touchstart touchend".split(" ").forEach(function(e){
        sliderBarControl.addEventListener(e, function(event){
            //set the loading UI
            _loadingUi((e=="touchend" ? false : true));
            //set the delta between the two slidebars
            let delta=sliderBarHolder.clientWidth-sliderBarControl.clientWidth;
            //seek to the new clicked point into the scrollbar
            setTimeout(_onSeek,500,event,sliderBarControl,delta);
        });
      });
      


}

/**
 * Override the on seek event for Video.Js
 * @param {*} event 
 * @param {*} slideBar 
 * @param {*} delta 
 */
function _onSeek(event,slideBar,delta=0){
    let rect = slideBar.getBoundingClientRect();
    let clientX=(event.clientX!=undefined ? event.clientX : event.touches[0].clientX); //set the touch if needed
    let x = clientX - (rect.left-(delta/2));
    let perc = 100 / (slideBar.clientWidth + delta) * x;
    contentPlaylist.forEach(function (item,index){
        if(perc>=item.previousPercentDuration && perc<=item.progressivePercentDuration && (player.lastSource===undefined || (player.lastSource!==undefined && item.URL!=player.lastSource_.player))){
            currentSourceIndex=index;
            _loadSrc(index);
            player.currentTime((playlistTotalDuration/100*perc)-(playlistTotalDuration/100*item.previousPercentDuration));
        }else if(perc>=item.previousPercentDuration && perc<=item.progressivePercentDuration){
            player.currentTime((playlistTotalDuration/100*perc)-(playlistTotalDuration/100*item.previousPercentDuration));
        }
    });
}

/**
 * Loading UI: disable or enable control bar
 * @param {*} status 
 * @param {*} playback 
 */
function _loadingUi(status=true,playback=false){
    if(status){
        document.getElementsByClassName("vjs-progress-control")[0].style.visibility='hidden';
        if (typeof document.getElementsByClassName("vjs-time-tooltip")[0] != "undefined")
            document.getElementsByClassName("vjs-time-tooltip")[0].style.visibility='hidden';
        player.controlBar.progressControl.disable();
    }else{
        document.getElementsByClassName("vjs-progress-control")[0].style.visibility='visible';
        if (typeof document.getElementsByClassName("vjs-time-tooltip")[0] != "undefined")
            document.getElementsByClassName("vjs-time-tooltip")[0].style.visibility='visible';
        player.controlBar.progressControl.enable();
        //proceed if the playback is true
        if(playback) player.play();
    }
}

/**
 * Set the Video.Js events
 */
function _setPlayerEvents(){
    //EVENT: the seeked is over
    player.on('seeked', function(){
        //stop loading UI
        setTimeout(_loadingUi,500,false,true);
    });

    //EVENT: the player is ready
    player.on('ready', function(){
        //load the source of the current item into the playlist
        _loadSrc(currentSourceIndex);
    });

    //EVENT: the content is successfully loaded
    player.on('loadedmetadata', function() {
        //set the playlist's duration
        _setDurations();
        //set the playlist's percentage stubs
        _setPercentagesToPlaylistItems();
        if(currentSourceIndex>0) player.play();
    });

    //EVENT: the playback is started
    player.on('play', function(){
        //remove the play button on the player
        document.getElementsByClassName("vjs-big-play-button")[0].style.display="none";
    });

    //EVENT: playback
    player.on('timeupdate', function() {
        //get the new and old progress bars
        let newProgressBar=document.getElementsByClassName("newProgressBar")[0];
        let oldProgressBarWidth=player.controlBar.progressControl.seekBar.playProgressBar.el_.style.width.replace("%","");
        //check the current index for the playlist and set the position of the playback pointer
        if(currentSourceIndex>0){
            if(player.currentTime()<1) oldProgressBarWidth=0;
            let pointerPosition=parseFloat(oldProgressBarWidth)+contentPlaylist[currentSourceIndex-1].progressivePercentDuration;
            newProgressBar.style.width=pointerPosition+"%";
        }else{
            newProgressBar.style.width=oldProgressBarWidth+"%";
        }
    });

    //EVENT: the playback is over
    player.on('ended', function() {
        if(contentPlaylist[currentSourceIndex+1] !== undefined){
            //switch to the next item into the playlist
            currentSourceIndex++;
            _loadSrc(currentSourceIndex);
        }else{
            //the entire playlist is over
            currentSourceIndex=0;
            _loadSrc(currentSourceIndex);
        }
    });
}

/**
 * Load the src of the item into the playlist for the selected index
 * @param {*} index 
 */
function _loadSrc(index){
    if(contentPlaylist[index] !== undefined){
        player.src(contentPlaylist[index].URL);
        player.load();
        player.play();
    }
}

/**
 * Set the duration for entire playlist
 */
function _setDurations(){
    //get current file duration
    currentFileDuration=contentPlaylist[currentSourceIndex].DURATION-contentPlaylist[currentSourceIndex].STARTTIME;
    //get total duration
    playlistTotalDuration=0;
    contentPlaylist.forEach(function (item){
        playlistTotalDuration+=item.DURATION;
    });
    //override the player's duration
    player.duration = function() {
        return playlistTotalDuration;
    }
}

/**
 * Set the playlist's percentage stubs
 */
function _setPercentagesToPlaylistItems(){
    let previousValue=0;
    contentPlaylist.forEach(function (item){
        item.progressivePercentDuration=100/playlistTotalDuration*item.DURATION+previousValue;
        item.percentDuration=100/playlistTotalDuration*item.DURATION;
        //set the percentage for the current item
        item.previousPercentDuration=previousValue;
        if(item.progressivePercentDuration>100)
            item.progressivePercentDuration=100;
        //remember the previous value
        previousValue=item.progressivePercentDuration;
    });
}

